(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password"]) return;
  try {
    
  if (!customElements.get('parant-password-video')) {
    customElements.define('parant-password-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPlaying = () => this.toggleAttribute('data-playing', !this.reducedMotion.matches);
        this.onError = () => this.removeAttribute('data-playing');
        this.onMotionChange = () => this.updatePlayback();
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('error', this.onError);
        this.reducedMotion.addEventListener('change', this.onMotionChange);
        this.updatePlayback();
      }

      disconnectedCallback() {
        if (!this.video) return;
        this.video.pause();
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('error', this.onError);
        this.reducedMotion.removeEventListener('change', this.onMotionChange);
      }

      updatePlayback() {
        if (this.reducedMotion.matches) {
          this.video.pause();
          this.removeAttribute('data-playing');
          return;
        }

        this.video.muted = true;
        this.video.play().catch(() => this.removeAttribute('data-playing'));
      }
    });
  }

  if (!customElements.get('parant-sydney-clock')) {
    // Sydney daylight from NOAA solar-position equations; no location permission or API needed.
    // https://gml.noaa.gov/grad/solcalc/solareqns.PDF
    const isSydneyDaylight = function(date) {
  const radians = Math.PI / 180;
  const year = date.getUTCFullYear();
  const yearStart = Date.UTC(year, 0, 1);
  const daysInYear = (Date.UTC(year + 1, 0, 1) - yearStart) / 86400000;
  const fractionalYear = 2 * Math.PI / daysInYear * ((date.getTime() - yearStart) / 86400000 - 0.5);
  const equationOfTime = 229.18 * (0.000075 + 0.001868 * Math.cos(fractionalYear)
    - 0.032077 * Math.sin(fractionalYear) - 0.014615 * Math.cos(2 * fractionalYear)
    - 0.040849 * Math.sin(2 * fractionalYear));
  const declination = 0.006918 - 0.399912 * Math.cos(fractionalYear)
    + 0.070257 * Math.sin(fractionalYear) - 0.006758 * Math.cos(2 * fractionalYear)
    + 0.000907 * Math.sin(2 * fractionalYear) - 0.002697 * Math.cos(3 * fractionalYear)
    + 0.00148 * Math.sin(3 * fractionalYear);
  const utcMinutes = date.getUTCHours() * 60 + date.getUTCMinutes() + date.getUTCSeconds() / 60;
  const solarMinutes = utcMinutes + equationOfTime + 4 * 151.2093;
  const hourAngle = (solarMinutes / 4 - 180) * radians;
  const latitude = -33.8688 * radians;
  const cosineZenith = Math.sin(latitude) * Math.sin(declination)
    + Math.cos(latitude) * Math.cos(declination) * Math.cos(hourAngle);
  return cosineZenith > Math.cos(90.833 * radians);
};

    customElements.define('parant-sydney-clock', class extends HTMLElement {
      connectedCallback() {
        this.zoneLabel = this.querySelector('[data-clock-zone]');
        this.timeLabel = this.querySelector('[data-clock-time]');
        this.daylightIcon = this.querySelector('[data-clock-daylight]');
        this.sunIcon = this.querySelector('[data-clock-sun]');
        this.moonIcon = this.querySelector('[data-clock-moon]');
        this.formatter = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
          timeZoneName: 'short'
        });
        this.updateClock();
      }

      disconnectedCallback() {
        window.clearTimeout(this.clockTimer);
      }

      updateClock() {
        window.clearTimeout(this.clockTimer);
        const now = new Date();
        const parts = this.formatter.formatToParts(now);
        const value = (type) => parts.find((part) => part.type === type).value;

        this.zoneLabel.textContent = 'Sydney ' + value('timeZoneName');
        this.timeLabel.textContent = value('hour') + ':' + value('minute') + ':' + value('second');

        const isDaylight = isSydneyDaylight(now);
        if (this.isDaylight !== isDaylight) {
          this.isDaylight = isDaylight;
          this.sunIcon.toggleAttribute('hidden', !isDaylight);
          this.moonIcon.toggleAttribute('hidden', isDaylight);
          this.daylightIcon.setAttribute('aria-label', isDaylight ? 'Daytime in Sydney' : 'Nighttime in Sydney');
          this.daylightIcon.setAttribute('title', isDaylight ? 'Daytime in Sydney' : 'Nighttime in Sydney');
          this.daylightIcon.hidden = false;
        }

        // Re-read the current time on every tick, including after a background tab resumes.
        this.clockTimer = window.setTimeout(() => this.updateClock(), 1000 - (Date.now() % 1000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
